import { Alert, AlertTitle, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ChannelSubItems } from "../../components/channel";
import SubHeading from "../../components/common/SubHeading";
import { useLocalStorage } from "../../hooks";
import { IChannel } from "../../models/channel";
import { useChannelStore } from "../../stores";
import { findChannelById, generateChannelPathById } from "../../utils";

const ChannelPage = () => {
  const { t } = useTranslation("page");
  const { channelId } = useParams<{ channelId: string }>();
  const { channels, channel, setChannelList } = useChannelStore();
  const { configures } = useLocalStorage();

  const [currentChannel, setCurrentChannel] = useState<IChannel | undefined>(
    {} as IChannel
  );
  const hasData = Boolean(
    currentChannel?.mediaContents?.length || currentChannel?.subChannels?.length
  );

  useEffect(() => {
    if (configures) {
      setChannelList(configures.communityConfiguration.channels);
    }
  }, []);

  useEffect(() => {
    let foundChannel: IChannel | undefined;
    const allChanels = configures?.communityConfiguration.channels || channels;

    if (channelId) {
      foundChannel = findChannelById(allChanels, channelId);

      setCurrentChannel(foundChannel);
    }
    // SubChannelId will have parentId before "-" - For e.g: parentId-channelId => 12-13
  }, [channels, channel, channelId]);

  const channelPath =
    (channelId && generateChannelPathById(channelId, channels).join("/")) || "";

  if (!currentChannel) {
    return (
      <Alert severity="warning">
        <AlertTitle>{t("channel.warning")}</AlertTitle>
        {t("channel.unableToLocateChannel")}
      </Alert>
    );
  }

  return (
    <Grid
      item
      container
      width="100%"
      height="100%"
      padding={{
        lg: "2rem 6rem",
      }}
      sx={{
        background: `url("${currentChannel?.backgroundImageSource}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
      }}
    >
      <Grid
        container
        item
        xs={12}
        direction="column"
        wrap="nowrap"
        alignItems="start"
        justifyContent="start"
      >
        <SubHeading>{currentChannel?.title}</SubHeading>

        <Grid
          item
          container
          xs={12}
          sx={{ overflowY: "auto" }}
          direction="column"
        >
          {hasData ? (
            <>
              <ChannelSubItems
                subChannels={currentChannel.subChannels}
                contents={currentChannel.mediaContents}
                parentChannelId={channelId!}
                parentChannelPath={channelPath}
              />
            </>
          ) : (
            <Typography color="white">No info available</Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChannelPage;
